class Hero {
    constructor() {
        this.class = {
            module: '.module-hero',
            parallaxImage: '.parallax-image img',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        this.parallaxImage();
    }

    parallaxImage() {
        const module = document.querySelector(this.class.module);

        if (!module) {
            return;
        }

        const image = module.querySelectorAll(this.class.parallaxImage);
        if (image) {
            new simpleParallax(image, {
                overflow: false,
                orientation: 'down',
                scale: 1.3, // Increase scale for a more noticeable effect
                delay: 0,
            });
        }
    }
}

export default new Hero();
